import * as yup from "yup";

export const ProductsValidation = yup.object().shape({
    name: yup
        .string()
        .required("Product name is required")
        .min(2, "Product name must be at least 2 characters")
        .max(100, "Product name must not exceed 100 characters")
        .trim(),
    
    image_url: yup
        .string()
        .nullable()
        .optional(),
    
    price: yup
        .number()
        .required("Price is required")
        .positive("Price must be a positive number")
        .typeError("Price must be a valid number"),
    
    mrp: yup
        .number()
        .nullable()
        .transform((value, original) => (original === "" || original === null ? null : value))
        .positive("MRP must be a positive number")
        .typeError("MRP must be a valid number")
        .test("mrp-not-below-price", "MRP cannot be lower than the sale price", function (mrp) {
            const { price } = this.parent;
            return mrp === null || mrp === undefined || !price || Number(mrp) >= Number(price);
        }),

    video_url: yup
        .string()
        .nullable()
        .trim()
        .test(
            "supported-video",
            "Use a YouTube link (watch, youtu.be or shorts) or an Instagram post/reel link",
            (value) =>
                !value ||
                /(youtube\.com\/(watch\?(.*&)?v=|shorts\/|embed\/|live\/)[\w-]{11})|(youtu\.be\/[\w-]{11})|(instagram\.com\/([\w.]+\/)?(p|reel|reels|tv)\/[\w-]+)/i.test(
                    value,
                ),
        ),

    images: yup.array().of(yup.string()).max(10, "A product can have at most 10 images"),

    description: yup
        .string()
        .max(1000, "Description must not exceed 1000 characters")
        .nullable()
        .optional(),
    
    is_active: yup
        .boolean()
        .default(true)
}); 